// extracted by mini-css-extract-plugin
export var TeamCard = "index-module--TeamCard--2cf9f";
export var TeamCardImage = "index-module--TeamCardImage--0bcaa";
export var TeamCardWrap = "index-module--TeamCardWrap--8e2f0";
export var TeamCardWrapLine = "index-module--TeamCardWrapLine--39246";
export var copyButton = "index-module--copyButton--aebf1";
export var copyIcon = "index-module--copyIcon--93fb2";
export var emailMe = "index-module--emailMe--d72c6";
export var name = "index-module--name--deae4";
export var telLink = "index-module--telLink--baa3d";
export var telephoneContainer = "index-module--telephoneContainer--80345";